function showError(msg)
{
	alert(msg);
}

var lastMouseX;
var lastMouseY;
var curPopupWindow = null;
var helpWindow = null;

function setLastMousePosition(e) {
    if (navigator.appName.indexOf("Microsoft") != -1)
    {
    	e = window.event;
    }
    lastMouseX = e.screenX;
    lastMouseY = e.screenY;
}

function openClickout(url) {
    window.open(url, "_blank", 'width=640,height=480,dependent=no,resizable=yes,toolbar=yes,status=yes,directories=yes,menubar=yes,scrollbars=1', false);
}

/**
 * Calls through to the openPopupFocus() with closeOnLoseFocus set to true.
 */
function openPopup(url, name, pWidth, pHeight, features, snapToLastMousePosition) {
    return openPopupFocus (url, name, pWidth, pHeight, features, snapToLastMousePosition, false);
}

/**
 * Used for help popup links that need #'s escaped inline.
 */
function openPopupFocusEscapePounds(url, name, pWidth, pHeight, features, snapToLastMousePosition, closeOnLoseFocus) {
    return openPopupFocus (url.replace("#","%23"), name, pWidth, pHeight, features, snapToLastMousePosition, closeOnLoseFocus);
}

/**
 * Handles popup windows.
 * If snapToLastMousePosition is true, then the popup will open up near the mouse click.
 * If closeOnLoseFocus is true, then it will close when the user clicks back into the browser window that opened it.
 */
function openPopupFocus(url, name, pWidth, pHeight, features, snapToLastMousePosition, closeOnLoseFocus) {
    //closePopup();

     if (snapToLastMousePosition) {
        if (lastMouseX - pWidth < 0) {
            lastMouseX = pWidth;
        }
        if (lastMouseY + pHeight > screen.height) {
            lastMouseY -= (lastMouseY + pHeight + 50) - screen.height;
        }
        lastMouseX -= pWidth;
        lastMouseY += 10;
        if(features.length!=0)
        	features += ",";
        features += "screenX=" + lastMouseX + ",left=" + lastMouseX + "screenY=" + lastMouseY + ",top=" + lastMouseY;
    }

    // assign the open window to a dummy var so when closePopup() is called it won't be assigned to curPopupWindow
    //alert(features);
    win = window.open(url, name, features, true);
    if(win)
    	win.focus ();
    return win;

}

function closePopup() {
    if (curPopupWindow != null) {

        if (!curPopupWindow.closed) {
            curPopupWindow.close();
        }
        curPopupWindow = null;
    }
}

function openLookup(baseURL, nm, width, height) {
    if (!width) width = 500;
    if (!height) height = 350;
    win = window.open(baseURL, nm, "width=" + width + ",height=" + height + ",toolbar=no,status=yes,statusbar=no,menubar=no,resizable=yes,scrollbars=yes,scrollable=yes", true);
    if(win)
    	win.focus ();
    return win;
    //return openPopup(baseURL, nm, width, height, "width=" + width + ",height=" + height + ",toolbar=no,status=yes,statusbar=no,directories=no,menubar=no,resizable=yes,scrollbars=yes,scrollable=yes", true,false);
}

function openLookupWithMenu(baseURL, nm, width, height) {
    if (!width) width = 500;
    if (!height) height = 350;
    win = window.open(baseURL, nm, "width=" + width + ",height=" + height + ",toolbar=yes,status=yes,statusbar=no,menubar=yes,resizable=yes,scrollbars=yes,scrollable=yes", true);
    if(win)
    	win.focus ();
    return win;
    //return openPopup(baseURL, nm, width, height, "width=" + width + ",height=" + height + ",toolbar=no,status=yes,statusbar=no,directories=no,menubar=no,resizable=yes,scrollbars=yes,scrollable=yes", true,false);
}

function pick(form,field,val) {
    eval("document."+form+"[\""+field+"\"].value=" + "\""+val+"\"");
    closePopup();
    return false;
}


//validate functions

function checkEmailFormat(val)
{
	var emailFilter=/^.+@.+\..{2,6}$/;
	if (!(emailFilter.test(val.value))) {
       		return false;
	}
	return true;
}

// VerifyEmail() verifies that the email address has the correct format
function VerifyEmail(email) {
	var at_pos;
	var pd_pos;
	var sp_pos;
	var em_len;

	// Make sure there is a value
	em_len = email.length;
	if (em_len < 1) {
	return -1;
	}

	// check for spaces
	sp_pos = email.indexOf(" ", 0);
	if (sp_pos != -1) {
	return -2;
	}

	// check for @ symbol
	at_pos = email.indexOf("@", 0);
	if (at_pos == -1) {
	return -3;
	}

	// check for period after the @ symbol
	pd_pos = email.indexOf(".", at_pos);
	if (pd_pos == -1) {
	return -4;
	}

	// check for period as last character
	if (pd_pos == (em_len - 1)) {
	return -5;
	}

	// make sure there is at least one character between the @ symbol and the .
	if (pd_pos == (at_pos + 1)) {
	return -6;
	}

	// make sure address doesn't start with an @ symbol
	if (at_pos == 0) {
	return -7;
	}
	return 1;
}

function isEmail(str) {
     var checkEmail;
     checkEmail = VerifyEmail(str);
     if (checkEmail < 0) {
          if (checkEmail == -1) {
               alert("Warning: Email address is blank.");
          }
          if (checkEmail == -2) {
               alert("Spaces are not allowed in email addresses.");
          }
          if (checkEmail == -3) {
               alert("There must be an @ symbol in an email address.");
          }
          if (checkEmail == -4) {
               alert("There must be a period after the @ symbol in an email address.");
          }
          if (checkEmail == -5) {
               alert("Email addresses can not end with a period.");
          }
          if (checkEmail == -6) {
               alert("There must be at least one character between the @ symbol and the period.");
          }
          if (checkEmail == -7) {
               alert("Email addresses can not begin with an @ symbol.");
          }
          return false
     }
     // Added by US111
     else
     {
     	return true;
     }
}

//js checking for contact login

//to handle submission
function submitItLogin(loginform) {
	if(!loginform)
		loginform=document.loginform;

	if(validatePageLogin(loginform))
		return true;
	else
	{
	showError("Incorrect username or password.");
		return false;
	}
}

//what rules to apply
function validatePageLogin(loginform)
{

	var MIN_LEN = 2;
	var MAX_LEN = 60;

	if(!loginform)
		loginform=document.loginform;

	var username = document.loginform.username.value;
	var password = document.loginform.password.value;

	return (!IsEmpty(username) && !IsEmpty(password)
			&& IsInBetween(username,MIN_LEN,MAX_LEN) && IsInBetween(password,MIN_LEN,MAX_LEN)
			&& !checkTags(username) && !checkTags(password));
}




//general validation functions
function IsEmpty(input)
{
	if(input.length > 0)
		return false;

	return true;
}

function IsGreaterEqualThan(input, min_len)
{
	if(input.length >= min_len)
		return true;

	return false;
}

function IsLessEqualThan(input, max_len)
{
	if(input.length <= max_len)
		return true;

	return false;
}

function IsInBetween(input, min_len, max_len)
{
	if((input.length > min_len) && (input.length < max_len))
		return true;

	return false;
}


function checkTags(input)
{
	input2 = escape(input);

	if(input.length == input2.length)
		return false;

	return true;
}

function checkSQLChars(input)
{
	return false;
}

function bookmarkSite(url,title)
{
	if (window.sidebar) // firefox
	{
		window.sidebar.addPanel(title, url, "");
	}
	else if(window.opera && window.print)
	{ // opera
		var elem = document.createElement('a');
		elem.setAttribute('href',url);
		elem.setAttribute('title',title);
		elem.setAttribute('rel','sidebar');
		elem.click();
	}
	else if(document.all)// ie
	{
		window.external.AddFavorite(url, title);
	}
}

/*
MyList is an array, each element is an array of 2 elements (representing option value & options text)
Populate the select list based the id: mySelectID
*/
function populateSelect(myList, mySelectID, valueSelected)
{
	if (document.getElementById && myList.length > 0)
	{
	   target = document.getElementById(mySelectID);
	   if (target)
	   {
	   		my_length = myList.length;
	   		//init:
	   		var selected_index    = 0;
	   		target.options.length = 0;

	   		for(i=0; i < my_length; i++ )
	   		{
	   			if (valueSelected == myList[i][0]) selected_index =  i;
	   			target.options[target.options.length] = new Option(myList[i][1], myList[i][0]);
	   		}
	   		//set the default selected option
	   		target.options.selectedIndex = selected_index;
	   }
	}
}

/*
This function reset the value for the given elementId.
*/
function setElementValueById(elementId, newValue)
{
	if (document.getElementById)
	{
		target = document.getElementById(elementId);
		if(target) target.value = newValue;
	}
}

/*
These functions are used for trimming extra whitespaces
*/
function ltrim(str) {
	for(var k = 0; k < str.length && isWhitespace(str.charAt(k)); k++);
	return str.substring(k, str.length);
}
function rtrim(str) {
	for(var j=str.length-1; j>=0 && isWhitespace(str.charAt(j)) ; j--) ;
	return str.substring(0,j+1);
}
function trim(str) {
	return ltrim(rtrim(str));
}
function isWhitespace(charToCheck) {
	var whitespaceChars = " \t\n\r\f";
	return (whitespaceChars.indexOf(charToCheck) != -1);
}


function VTK_showDiv(div_id)
{
	if (document.getElementById)
	{
		var my_style = document.getElementById(div_id).style;
		    my_style.display = "block";
	}
	else if (document.all)
	{
		var my_style = document.all[div_id].style;
		    my_style.display = "block";
	}
	else if(document.layers)
	{
		var my_style = document.layers[div_id].style;
		    my_style.display = "block";
	}
}

function VTK_hideDiv(div_id)
{
	if (document.getElementById)
	{
		var my_style = document.getElementById(div_id).style;
		    my_style.display = "none";
	}
	else if (document.all)
	{
		var my_style = document.all[div_id].style;
		    my_style.display = "none";
	}
	else if(document.layers)
	{
		var my_style = document.layers[div_id].style;
		    my_style.display = "none";
	}
}

function VTKToolTipShow(options)
{
	//get window view port:
	var view_port = {width: $(window).width(), height: $(window).height(),scrollLeft: $(document).scrollLeft(), scrollTop: $(document).scrollTop()};


	var checkOffset = false;
	if (options.checkOffset)
		checkOffset = true;

	//get all options
	var source_id           = options.source_id;      //where the tool tip contents comes from
	var destination_id      = options.destination_id; //tooltip div id
	var element_id          = options.element_id;     //for which element
	var delayed_close       = options.delayed_close;
	var tooltip_width       = options.tooltip_width;
	var tooltip_start_point = options.tooltip_start_point //supports 'topLeft' and 'topRight' only
	var tooltip_top_offset  = options.tooltip_top_offset;
	var tooltip_left_offset = options.tooltip_left_offset;
	if(typeof(options.fixed_position) == 'undefined')
	{
		var fixed_position  = false;
	}
	else
	{
		var fixed_position  = options.fixed_position;
	}

	var $source      = $('#' + source_id);
	var $destination = $('#' + destination_id);
	var $element     = $('#' + element_id);

	//copy $source contents into $destination:
	$destination.html($source.html());

	var $element_position = $element.position();

	//check element's offet values to the DOM
	var $offsetTop  = 0;
	var $offsetLeft = 0;
	if (checkOffset)
	{
		$element_offset   = $element.offset();
		$offsetTop  = $element_offset.top;
		$offsetLeft = $element_offset.left;
	}

	$element_width    = $element.width();
	$element_height   = $element.height();

	if (tooltip_start_point == 'topLeft')
	{ //top left:
		$my_top  = parseInt($element_position.top) + parseInt($offsetTop);
		$my_left = parseInt($element_position.left)+ parseInt($offsetLeft);
	}
	else
	{ //top right and other
		$my_top  = parseInt($element_position.top)  + parseInt($offsetTop);
		$my_left = parseInt($element_position.left) + $element_width + parseInt($offsetLeft);
	}
	$my_top  = $my_top  + parseInt(tooltip_top_offset);
	$my_left = $my_left + parseInt(tooltip_left_offset);

	if(fixed_position)
	{
	}
	else
	{
		//check vertical position:
		var current_height = parseInt(view_port.height) + parseInt(view_port.scrollTop);
		if (current_height < $my_top + $destination.height())
		{   //here we need to adjust the top position and move the tooltip to the top of the element:
			//$my_top = parseInt($element_position.top) - parseInt($destination.height()) - 10;
			$my_top = current_height - $destination.height() - 10 ;
		}
		else if($my_top < parseInt(view_port.scrollTop))
		{
			$my_top = parseInt(view_port.scrollTop) + 10;
		}

		//check horizontal position:
		var current_width = parseInt(view_port.width) + parseInt(view_port.scrollLeft);
		if (current_width < $my_left + $destination.width())
		{   //here we need to adjust the left position and move the tooltip to the left of the element:
			$my_left = parseInt($element_position.left)+ parseInt($offsetLeft) - $destination.width() - parseInt(tooltip_left_offset) + 2 ;
		}
	}

	$destination.css({'z-index': 999999 ,position: 'absolute',top: $my_top , left: $my_left});
	if (tooltip_width > 0)
	{
		$my_width = tooltip_width + 'px'
		$destination.css({'width': $my_width});
	}
	$destination.show();

	function closeMe()
	{
		$destination.hide().empty();
	}

	if (delayed_close > 0)
	{
		setTimeout(closeMe, delayed_close);
	}
}
function VTKHideToolTip(tooltip_id)
{
	$('#' + tooltip_id).hide().empty();
}

function toggle_two_divs(div_one, div_two)
{
	if(jQuery('#' + div_one).css('display').toLowerCase() == 'block')
	{
	    //div one is open, hide it
	    jQuery('#'+div_one).hide();
	    jQuery('#'+div_two).show();
	}
	else
	{
	    //div one is closed, show it
		jQuery('#'+div_one).show();
		jQuery('#'+div_two).hide();
	}

}

function toggle_div_and_image(div_to_toggle, img_to_toggle, text_to_toggle)
{
	var div_status = jQuery('#' + div_to_toggle).css('display');
	if(div_status.toLowerCase() == 'block')
	{
	    //div is open, hide it
	    jQuery('#'+div_to_toggle).hide();
	    jQuery('#'+img_to_toggle).attr('src','/images/arrow_right.gif');
	    jQuery('#'+text_to_toggle).html('Show');
	}
	else
	{
	    //div is closed, show it
		jQuery('#'+div_to_toggle).show();
		jQuery('#'+img_to_toggle).attr('src','/images/arrow_down.gif');
		jQuery('#'+text_to_toggle).html('Hide');
	}
}

function VTKClickThroughTracker(obj, contact_id, url_type){



	var tmpImage = new Image();
	var url = obj.href; //the url

	//iterate until last child to get link text
	while(obj.nodeType == 1){
		obj = obj.firstChild;
	}
	var url_title = obj.nodeValue;

	tmpImage.src = '/click_through.php?contact_id=' + contact_id + '&url_type=' + url_type + '&url=' + escape(url) + '&url_title=' + escape(url_title) + '&v=' + (new Date()).getTime();
}

function setCookie(c_name, value, expiredays, path, domain, secure)
{
	var exdate=new Date();

	exdate.setDate(exdate.getDate() + parseInt(expiredays));

	document.cookie = c_name+ "=" +escape(value)+
	((expiredays==null) ? "" : ";expires=" + exdate.toGMTString()) +
	((path==null) ? "" : ";path=" + escape(path)) +
	((domain==null) ? "" : ";domain=" + escape(domain)) +
	((secure==null) ? "" : ";secure");

}
function getCookie(c_name)
{
	if (document.cookie.length>0)
	{
	  	var c_start=document.cookie.indexOf(c_name + "=");
	  	if (c_start!=-1)
	    {
		    c_start=c_start + c_name.length+1;
		    var c_end=document.cookie.indexOf(";",c_start);
		    if (c_end==-1) c_end=document.cookie.length;
		    return unescape(document.cookie.substring(c_start,c_end));
	    }
	}
	return "";
}

function validateSubscribeForm(form)
{
	var full_name = trim(form.full_name.value);

	space_pos = full_name.indexOf(" ");

	if(space_pos != -1) {
		var first_name = full_name.substring(0, space_pos);
		var last_name = full_name.substring(space_pos, full_name.length);
	}
	else
	{
		var first_name = full_name;
		var last_name = "";
	}
	form.FirstName.value = first_name;
	form.LastName.value = last_name;

	var error_msg = "";
	var focus_flag = false;

	if(trim(form.FirstName.value).length == 0)
	{
		error_msg += "'Name' is a mandatory field" + '\r\n';
		if(!focus_flag)
		{
			form.full_name.focus();
			focus_flag = true;
		}
	}
	if(trim(form.Email.value).length == 0)
	{
		error_msg += "'Email' is a mandatory field." + '\r\n';
		if(!focus_flag)
		{
			form.Email.focus();
			focus_flag = true;
		}
	}
	if(!validateEmail(form.Email.value))
	{
		error_msg += "'"+ form.Email.value + "' is an invalid email address." + '\r\n';
		if(!focus_flag)
		{
			form.Email.focus();
			focus_flag = true;
		}
	}
	if(trim(form.PostalCode.value).length == 0)
	{
		error_msg += "'Postcode' is a mandatory field." + '\r\n';
		if(!focus_flag)
		{
			form.PostalCode.focus();
			focus_flag = true;
		}
	}

	if(error_msg.length > 0)
	{
		alert(error_msg);
		return false;
	}
	else
	{

		return true;
	}
}

function validateSubscribeFormSimple()
{
	var form = document.em_subscribe_form_simple;

	var error_msg = "";
	var focus_flag = false;

	if(trim(form.em_wfs_formfield_1576793.value).length == 0)
	{
		error_msg += "'Email' is a mandatory field." + '\r\n';
		if(!focus_flag)
		{
			form.em_wfs_formfield_1576793.focus();
			focus_flag = true;
		}
	}
	if(!validateEmail(form.em_wfs_formfield_1576793.value))
	{
		error_msg += "'"+ form.em_wfs_formfield_1576793.value + "' is an invalid email address." + '\r\n';
		if(!focus_flag)
		{
			form.em_wfs_formfield_1576793.focus();
			focus_flag = true;
		}
	}

	if(error_msg.length > 0)
	{
		alert(error_msg);
		return false;
	}
	else
	{
		return true;
	}
}

function validateEmail(addr)
{
	var _e_r = new RegExp("^([\\#\\$\\&'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\}\\|\\~a-zA-Z0-9-]+(\\.[\\#\\$\\&'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\}\\|\\~a-zA-Z0-9-]+)*@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+)?$");
    return _e_r.test(addr);
}

function getParentHeightByChildHeight(child_element_class, parent_element_class, extra_increments)
{
	 var tallest_column = 0;
	 jQuery(child_element_class).each(
		 function()
		 {
			 currentHeight = jQuery(this).height();
			 if(currentHeight > tallest_column)
			 {
				tallest_column  = currentHeight;
			 }
		 }
	 );

	var parent_height = tallest_column;
	if(typeof(extra_increments) != 'undefined')
	{
		parent_height = parent_height + extra_increments;
	}
	return parent_height;
}

function setElementHeight(element_class, element_height) {
	jQuery(element_class).height(element_height);
}

function setParentHeight(element, extra_increments)
{
	var contentHeight = jQuery(this).height();

	if(typeof(extra_increments) != 'undefined')
	{
		contentHeight = contentHeight + extra_increments;
	}
	jQuery(element).height(contentHeight);
}

function changeElementOffsetTop(element, offset_top)
{
	jQuery(element).css({top: offset_top});
}

function makeElementVisible(element_id) {
	jQuery('#'+element_id).css('visibility', 'visible');
}

function makeElementHidden(element_id) {
	jQuery('#'+element_id).css('visibility', 'hidden');
}

function getDomainName(url)
{
	var domain_name = "";

	//only process if url length > 0
	if ((url != '')&&(typeof url == 'string'))
	{
		url = url.toLowerCase();

		var url_parts = url.split("/");
		var is_http = url.indexOf("http://");
		var is_https = url.indexOf("https://");

		if(is_http == -1 && is_https == -1)
		{
			/*
				condition 1 - url doesnt contain http or https
				we make assumption that domain_name is whatever text before the first /
				e.g www.google.com
			*/
			domain_name = url_parts[0];

		}
		else
		{
			/*
				condition 2 - url contain http or https
				domain name is located between http(s):// and the first occurence of the next /
			*/
			domain_name = url_parts[2];
		}
	}

	return domain_name;
}

/* STARTS Marketo Field Validations */

	function fieldValidate(field) {
	  /* call Mkto.setError(field, message) and return false to mark a field value invalid */
	  /* return 'skip' to bypass the built-in validations */
	  return true;
	}

	function getRequiredFieldMessage(domElement, label) {
	  return "This field is required";
	}

	function getTelephoneInvalidMessage(domElement, label) {
	  return "Please enter a valid phone number";
	}

	function getEmailInvalidMessage(domElement, label) {
	  return "Please enter a valid email";
	}

/* END Marketo Field Validations */

function submitItSFforms() {
	var form = document.form;

	if (!validateSFforms()) {
		return false;
	}

	if ('undefined' !== typeof  vtk_cid) {
       form.Campaign_ID.value = vtk_cid;
    }

	//add first referrer and most referrer information
	var first_referrer   = new Cookie("f_ref"); //first referrer
	var recent_referrer  = new Cookie("mr_ref"); //most recent referrer

	//set first referrer
	document.getElementById('00N20000002afJG').value = first_referrer.ref_url;

	//set first referrer url
	document.getElementById('00N20000002Tw9K').value = getDomainName(first_referrer.ref_url);

	//set most recet referrer
	document.getElementById('00N20000002afJL').value = recent_referrer.ref_url;

	//set most recent referrer url
	document.getElementById('00N20000002TwCY').value = getDomainName(recent_referrer.ref_url);

	form.submit();
}

function validateSFforms(){
	var form = document.form;

    form.first_name.value	= trim(form.first_name.value);
	form.last_name.value	= trim(form.last_name.value);
	form.email.value	= trim(form.email.value);
	form.company.value	= trim(form.company.value);
	form.state.value	= trim(form.state.value);
	form.phone.value	= trim(form.phone.value);

	if (form.first_name.value.length < 1) {
		alert( "Please enter a valid contact name." );
		form.first_name.focus();
		return false;
	}
	else if (form.last_name.value.length < 1) {
		alert( "Please enter a valid contact name." );
		form.last_name.focus();
		return false;
	}
	else if (form.company.value.length < 1) {
		alert( "Please enter a company name." );
		form.company.focus();
		return false;
	}
	else if (form.state.value.length < 1) {
		alert( "Please enter a state." );
		form.state.focus();
		return false;
	}
	else if (form.email.value.length < 1) {
		alert( "Please enter a valid Email Address." );
		form.email.focus();
		return false;
	}
	else if(!validateEmail(form.email.value)) {
		alert("'"+form.email.value+"'" + " is an invalid email address." );
		form.email.focus();
		return false;
	}
	else if (form.phone.value.length < 1) {
		alert( "Please enter a valid contact number." );
		form.phone.focus();
		return false;
	}

	return true;

}


/**
 * added for decoding base64 codes
 */
function base64_decode(input)
{
	var keyStr = "ABCDEFGHIJKLMNOP" +
		   "QRSTUVWXYZabcdef" +
		   "ghijklmnopqrstuv" +
		   "wxyz0123456789+/" +
		   "=";
	var output = "";
	var chr1, chr2, chr3 = "";
	var enc1, enc2, enc3, enc4 = "";
	var i = 0;

	// remove all characters that are not A-Z, a-z, 0-9, +, /, or =
	var base64test = /[^A-Za-z0-9\+\/\=]/g;
	if (base64test.exec(input)) {
	    // ignore errors
	}
	input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

	do {
    	enc1 = keyStr.indexOf(input.charAt(i++));
    	enc2 = keyStr.indexOf(input.charAt(i++));
    	enc3 = keyStr.indexOf(input.charAt(i++));
    	enc4 = keyStr.indexOf(input.charAt(i++));

    	chr1 = (enc1 << 2) | (enc2 >> 4);
    	chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
    	chr3 = ((enc3 & 3) << 6) | enc4;

    	output = output + String.fromCharCode(chr1);

    	if (enc3 != 64) {
    	   output = output + String.fromCharCode(chr2);
    	}
    	if (enc4 != 64) {
    	   output = output + String.fromCharCode(chr3);
    	}

    	chr1 = chr2 = chr3 = "";
    	enc1 = enc2 = enc3 = enc4 = "";
	} while (i < input.length);

	return unescape(output);

}// end base64_decode

function VTK_store_ad_click(site_id, ad_click_id)
{
	if(site_id && ad_click_id){
		var vtkclick= new Cookie('vtkclick','|',':');
		vtkclick[site_id] = ad_click_id;
		
		//here we need to check ad_group_id, which will be the third argument.
		if (arguments[2]){
			var ad_group_id = arguments[2];
			vtkclick[site_id] = ad_click_id + '-' + ad_group_id;
		}
		vtkclick.store(24,'hours', '/');
	}
}


/**
 * wrapper for 
 * GA tracking
 */
function getGAEventTrackingCode(google_event_type, event_action, event_label)
{
    if (typeof(pageTracker) != 'undefined') { 
    	pageTracker._trackEvent(google_event_type, event_action, event_label); 
    }  
    
}// end getGAEventTrackingCode

/*
	This function loops through arguments passed in 
	and shows the element from the first argument and 
	hides all other elements arguments
	
	We made this function more generic so it can accept IDs or Classes
	showElementFromFirstArgument('#div_one', '#div_two', '.div_three');
*/
function showElementFromFirstArgument()
{
	if (arguments.length > 0)
	{
		var j = arguments.length;
		for (var i = 0; i<j; i++){
	        if(i == 0)
	        {
	        	jQuery(arguments[i]).removeClass('hidden').addClass('block');
	        }
	        else
	        {
	        	jQuery(arguments[i]).addClass('hidden').removeClass('block');
	        }
	    }
	}
}

/**
* phone track once click function
* @param {String}  _element   - element
* @param {String}  _type      - different types of phone track element's parent
* @return {Boolean}           - true or false
*
*/
window.phoneTrackOnceClick = function phoneTrackOnceClick(_element,_type,_hui) {

  if(typeof _hui == 'undefined') { _hui = false; }
  if(_type=='1'){
    if(_hui) {
      _element.prev().after('<span>'+un[_element.attr('data-sei')](_element.attr('data'))+'</span>');
    } else {
      _element.prev().after('<strong class="mls">'+un[_element.attr('data-sei')](_element.attr('data'))+'</strong>');
    }
    _element.remove();
    return false;
  }
  else if(_type=='2'){
    if(_hui) {
      _element.prev().after('<span>'+un[_element.attr('data-sei')](_element.attr('data'))+'</span>');
    } else {
      $('strong',_element[0]).html(un[_element.attr('data-sei')](_element.attr('data')));
      _element.parent('div').append(_element.html());
    }
    _element.remove();
    return false;
  }
  else if(_type=='3'){
    if(_hui) {
      _element.prev().after('<span>'+un[_element.attr('data-sei')](_element.attr('data'))+'</span>');
    } else {
      _element.prev().after('<strong class="mls">'+un[_element.attr('data-sei')](_element.attr('data'))+'</strong>');
    }
    _element.remove();
    return false;
  }
  else if (_type=='4'){
    if(_hui) {
      _element.prev().after('<span>'+un[_element.attr('data-sei')](_element.attr('data'))+'</span>');
      _element.remove();
    } else {
      $('span',_element[0]).html(un[_element.attr('data-sei')](_element.attr('data')));
      _element.parent('td').html(_element.html());
    }
    return false;
  }
}

/**
* change the browser address bar url
* @param {String}  title   - title
* @param {String}  url     - url to display on browser address bar
*
*/
function pushStateURL(title, url)
{
	try {
		window.history.pushState('', title, url);
	} catch (e) {
		// do nothing.
	}
}

function addTarget(target_type)
{
	jQuery(document).ready(function(){						
		if(target_type.location != window.location)
			jQuery("a.add_target").attr("target","_"+target_type);
	});
}

function revealMore(element_to_show, element_to_hide, element_to_enlarge)
{
	jQuery(element_to_show).show();
	jQuery(element_to_hide).remove();
	if(typeof(element_to_enlarge)!= 'undefined')
	{
		jQuery(element_to_enlarge).height(jQuery(element_to_enlarge).height() + jQuery(element_to_show).height());
	}
}

/* begin - SERP Get Quotes */

function onClickSerpGetQuotesSelectControl(target, data){
	//for serp version 2
	if(jQuery(target).parent('[id^=serp_block_content_]').length) {		
		jQuery(target).toggleClass('btn_tertiary btn_plain');
	}
	//for serp version 3
	if(jQuery(target).closest('#searchResultsWrapper').length) {
		jQuery(target).toggleClass('red tertiary_hue_light');
	}
    
	checkbox = jQuery(target).next('input');
    // faking tick/untick
	if(jQuery(checkbox).is(':checked') ){
		jQuery(checkbox).removeAttr('checked');	
		jQuery(target).html(getSerpGetQuotesButtonContent('add'));
	}
	else{
		jQuery(checkbox).attr('checked', 'checked');		
		jQuery(target).html(getSerpGetQuotesButtonContent('remove')).removeClass('hidden');
	}
    onClickSerpGetQuotesSelectCheckbox(checkbox, data);
}

function onClickSerpGetQuotesSelectCheckbox(target, data){
	// decode the data from URL encoded format - then we should get json
	data = jQuery.parseJSON(decodeURIComponent(data));
	
	// ticking or un-ticking
	ticking = 0;
	if( jQuery(target).is(':checked') ){
		ticking = 1;
	}
	data.ticked = ticking;
		
	url = '/get_quotes_serp/ajax?function=toggle_select';
	jQuery.ajax({
		url : url,
		type: "POST",
		dataType : 'json',
		data: data,
		success : function(data){
			if(data.success){			
				
				// update selection count
				updateSerpGetQuotesCount(data.count);
				
				if(data.added){
					// update shortlist count
					//jQuery('#header_shortlist_number').html(parseInt(data.shortlist_count));
				}
				
				// auto untick other replicates for this listing
				if(data.removed_dom_class){
					jQuery('.'+data.removed_dom_class).removeAttr('checked');
					jQuery('.'+data.removed_dom_class).prev('a').html(getSerpGetQuotesButtonContent('add'));										
				}
				  
				/*
				do different thing when selection added or removed
				if(data.added){
				}
				else if(data.removed){
				}
				*/
			}
			else{ 
				if(data.error){
					error_message = data.error;
				}
				
				// undo checkbox ticking
				if(ticking){
					jQuery(target).removeAttr('checked');	
				}
				else{
					jQuery(target).attr('checked', 'checked');
				}
				
				alert(error_message);
			}
		}, // end success
		error : function(jqXHR, textStatus){

		}
	}); // end ajax
}


function getSerpGetQuotesCount(){
	count = jQuery('.serp_gq_select_count_number').val();
	count = parseInt(count);
	return count;
}

function updateSerpGetQuotesCountOnly(count) {
	count = parseInt(count);
	var word = VTK_String.pluralWord('business','businesses',count);
	
	
	jQuery('.serp_gq_select_count_number').val(count);
	jQuery('.serp_gq_select_count_display').text(count);	
	jQuery('.serp_gq_select_count_display_word').html(word);
}

function refreshSerpGetQuotesSelection() {
	url = '/get_quotes_serp/ajax?function=get_selection&v='+Math.random();
	
	jQuery.ajax({
		url : url,
		type: "GET",
		dataType : 'json',
		success : function(data){
			if(data.success){  

				// update selection count
				updateSerpGetQuotesCountOnly(data.count);
				callVTK_Scroll_Follow_ToolbarInit();	
				
				if(data.count > 0)
					hideSerpGetQuotesExplanation();	
				else
					showSerpGetQuotesExplanation();	

				//reset all first
				jQuery('.serp_gq_select_checkbox').removeAttr('checked');
				jQuery('a.add_to_job').html(getSerpGetQuotesButtonContent('add'));
				getSerpGetQuotesLinkState(jQuery('a.add_to_job'),'add');
				
				var selected_dom_classes = data.selected_dom_classes;

				for(var i=0; i<selected_dom_classes.length;i++) {					
					jQuery('.'+selected_dom_classes[i]).attr('checked','checked');					
					jQuery('.'+selected_dom_classes[i]).prev('a.add_to_job').html(getSerpGetQuotesButtonContent('remove'));	
					getSerpGetQuotesLinkState(jQuery('.'+selected_dom_classes[i]).prev('a.add_to_job'),'remove');
				}				
			}
			else{ 
				if(data.error){
					error_message = data.error;
				}
				alert(error_message);
			}
		}, // end success
		error : function(jqXHR, textStatus){

		}
	}); // end ajax
	
	return false;
}

function showSerpGetQuotesExplanation(){
	jQuery('#gq_serp_floating_bar_selection_made').addClass('hidden');
	jQuery('#gq_serp_floating_bar_no_selection').removeClass('hidden');
}

function hideSerpGetQuotesExplanation(){
	jQuery('#gq_serp_floating_bar_no_selection').addClass('hidden');
	jQuery('#gq_serp_floating_bar_selection_made').removeClass('hidden');
}

function updateSerpGetQuotesCount(count){

	count = parseInt(count);
	
	if(count > 0) {								
		hideSerpGetQuotesExplanation();		
		var bar_height = jQuery('#footer_follow_toolbar_content').height();
		if(bar_height > 0){
			jQuery('#footer_follow_toolbar_content').animate({height:bar_height+20},400,"swing",function(){
				jQuery('#footer_follow_toolbar_content').animate({height:bar_height},250,"swing");
			});			
		}
		if(jQuery(window).scrollTop() == 0) {
			jQuery(window).scrollTop(100);
		}
	} else {
		showSerpGetQuotesExplanation();		
	}	
	
	updateSerpGetQuotesCountOnly(count);
	jQuery('#footer_follow_toolbar_content').css({'height':'auto'});
}

function onClickSerpGetQuotesClearAll(){
	// check how many in selection
	count = getSerpGetQuotesCount();
	if(!count){
		return false;
	}
		
	url = '/get_quotes_serp/ajax?function=clear_selection';
	
	jQuery.ajax({
		url : url,
		type: "GET",
		dataType : 'json',
		success : function(data){
			if(data.success){
				
				// update selection count
				updateSerpGetQuotesCount(data.count);
				
				// clear checkboxes
				jQuery('.serp_gq_select_checkbox').removeAttr('checked');
				jQuery('a.add_to_job').html(getSerpGetQuotesButtonContent('add'));
				getSerpGetQuotesLinkState(jQuery('a.add_to_job'),'add');				
			}
			else{ 
				if(data.error){
					error_message = data.error;
				}
				alert(error_message);
			}
		}, // end success
		error : function(jqXHR, textStatus){

		}
	}); // end ajax

	//jQuery('#footer_follow_toolbar').addClass('hidden').css('display','none');
	
	return false;
}


function onClickSerpGetQuotesGetQuotes(target){
	
	// prepare lightbox
	url = jQuery(target).attr('href');
	width = Math.min(980, $(window).width()-50);
	height = Math.min(510, $(window).height()-50);
	
	// fire lightbox
	iImageBrowser.dialog.open(url,width,height,'iframe',0);
	
	// done
	return false;
}

function getSerpGetQuotesLinkState(target, action) {
	if(action == 'add') {
		if(jQuery(target).closest('#searchResultsWrapper').length && jQuery('a.add_to_job').hasClass('red')) {
			jQuery(target).addClass('tertiary_hue_light').removeClass('red');
		}				
	} else if(action == 'remove'){
		if(jQuery(target).closest('#searchResultsWrapper').length && jQuery('a.add_to_job').hasClass('tertiary_hue_light')) {
			jQuery(target).addClass('red').removeClass('tertiary_hue_light');
		}
	}
}

function getSerpGetQuotesButtonContent(action) {
	if(action == 'add'){
		return '<span class="block unit sprite sprite_add mrs">Add</span> Shortlist';
	} else if(action == 'remove'){
		return '<span class="block unit sprite sprite_remove mrs">Remove</span> Remove';
	}
}

/* End - SERP Get Quotes */


/* Begin - Directory Get Quotes */

function onClickDirectoryGetQuotesGetQuotes(target)
{
	if (!VTK_Mobile.isMobile()) 
	{
		// prepare lightbox
		url = jQuery(target).attr('href');
		width = Math.min(840, $(window).width()-50);
		height = Math.min(510, $(window).height()-50);
		
		// fire lightbox
		iImageBrowser.dialog.open(url,width,height,'iframe',0);
		
		// done
		return false;
	}
	else
	{
		jQuery(target).attr('target','_self')
	}	
}

/* End - Directory Get Quotes */



/* begin - Search Page Refine Search Box control click  */

function onClickRefineSearchBoxParentCategory(target){
    cat_id = jQuery(target).val();
    cat_text = jQuery(target).find('option:selected').text();
    
    ga_label = 'Cat:' + cat_id + '-' + cat_text;
    
    
    getGANonInteractiveEventTrackingCode('Local Directory Search', 'Clicked Parent Categories Dropdown', ga_label);
    
}

function onClickRefineSearchBoxSubCategory(target){
    
    cat_id = parseInt(jQuery('#search_practice').val());
    cat_text = jQuery('#search_practice').find('option:selected').text();
    
    sub_cat_id = parseInt(jQuery(target).val());
    if(isNaN(sub_cat_id)){
        sub_cat_id = '0';
    }
    sub_cat_text = jQuery(target).find('option:selected').text();
    
    ga_label = 'Cat:' + cat_id + '-' + cat_text + ' | SubCat:' + sub_cat_id + '-' + sub_cat_text;
    
    
    getGANonInteractiveEventTrackingCode('Local Directory Search', 'Clicked Sub Categories Dropdown', ga_label);
}

function onClickRefineSearchBoxWhere(target){
    
    ga_label = jQuery(target).val();
    
    getGANonInteractiveEventTrackingCode('Local Directory Search', 'Clicked Where Textbox', ga_label);
}
/* End - Search Page Refine Search Box control click  */

function clickTestimonialTextHeadReadMore(elem){
    jQuery(elem).closest('.serp_result_testimonial_text').text(VTK_String.stripslashes(jQuery(elem).closest('.serp_result_testimonial_text').data('full-text')));
    return false;
}





// WEBPACK FOOTER //
// ../legacy/src/legacy/js/functions.js